import classnames from 'classnames';
import type { ElementType, FC, HTMLAttributes } from 'react';
import styles from './Title.module.scss';
type ComponentProps = HTMLAttributes<HTMLOrSVGElement> & {
  as?: ElementType;
  className?: string;
};
export const Title: FC<ComponentProps> = ({
  as: Tag = 'h1',
  className,
  ...otherProps
}) => <Tag className={classnames(styles.title, className)} {...otherProps} data-sentry-element="Tag" data-sentry-component="Title" data-sentry-source-file="index.tsx" />;